// extracted by mini-css-extract-plugin
export default {"feedback":"CustomInputFeedback_feedback__SdLbW"};